import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography from "@insite/mobius/Typography";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
});

type Props = ReturnType<typeof mapStateToProps>;
const WelcomeThanks = ({ session }: Props) => {
    if (!session.isAuthenticated && typeof window !== "undefined") {
        const history = useHistory();
        history.push("/");
    }

    return (
        <>
            <Typography
                variant="h3"
                as="h3"
                css={css`
                    width: 100%;
                `}
            >
                {session?.firstName},
            </Typography>
            <Typography
                variant="p"
                as="p"
                css={css`
                    width: 100%;
                `}
            >
                Thank you for registering with SupplyLand. We sent a confirmation message to {session?.email}
            </Typography>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(WelcomeThanks),
    definition: {
        group: "Testing",
        icon: "Banner",
    },
};

export default widgetModule;
